import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import axios from "axios";
import {
  FormLabel,
  ModalError,
  ModalSuccess,
  PrimaryButton,
  SecondaryButton,
  TextInput,
} from "components";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { getErrors } from "utils";

const ModalFormParameterRevenueType = ({
  open,
  onClose,
  preload,
  getDataTable,
}) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingButton, setLoadingButton] = useState(false);
  const [payload, setPayload] = useState({
    name: "",
    description: "",
  });

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };

  const handleSubmit = async () => {
    const method = preload ? axios.put : axios.post;
    try {
      setLoadingButton(true);
      await method(
        `${hardBaseUrl}/revenue-type/${
          preload ? `update/${preload?.revenue_type_id}` : "create"
        }`,
        payload,
        { headers }
      );
      ModalSuccess(
        `Successfully ${preload ? "Update" : "Create"} Revenue Type`
      ).then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton(false);
      onClose();
    }
  };
  useEffect(() => {
    if (preload) {
      setPayload({
        name: preload?.name,
        description: preload?.description,
      });
    }
  }, [preload]);
  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>{`${preload ? "Edit" : "Add"} Revenue Type`}</DialogTitle>
      <DialogContent dividers>
        <Grid container direction="column" rowSpacing={1}>
          <Grid item>
            <FormLabel label="Revenue Type Name" required />
            <TextInput
              value={payload?.name}
              onChange={e => handleChangePayload(e?.target?.value, "name")}
              placeholder="Name"
              disabled={loadingButton}
            />
          </Grid>
          <Grid item>
            <FormLabel label="Description" />
            <TextInput
              multiline
              rows={4}
              value={payload?.description}
              onChange={e =>
                handleChangePayload(e?.target?.value, "description")
              }
              placeholder="Description"
              disabled={loadingButton}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          label="Cancel"
          disabled={loadingButton}
          onClick={onClose}
        />
        <PrimaryButton
          label={loadingButton ? "Saving" : "Save"}
          loading={loadingButton}
          disabled={loadingButton}
          onClick={handleSubmit}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalFormParameterRevenueType;
